import { Directive, HostListener, Input, Type, inject } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { WA_NAVIGATOR } from '@ng-web-apis/common';
import { UntilDestroy } from '@ngneat/until-destroy';
import { updateUtmTagsInUrl } from '@rma/generic/ui/share/domain';
import type { ShareButtonFallbackModalComponent } from '@rma/generic/ui/share/private/ui-share-button-fallback-modal';

@UntilDestroy()
@Directive({
  selector: 'button[rmaShare]',
  standalone: true,
  providers: [MatBottomSheet],
})
export class ShareButtonDirective {
  private readonly bottomSheet = inject(MatBottomSheet);
  private readonly navigator = inject<Navigator>(WA_NAVIGATOR);

  @Input()
  data: ShareData | null | undefined;

  @HostListener('click')
  public onClick(): void {
    if (!this.data) {
      console.error('data must be provided');
      return;
    }

    if (!!this.navigator.canShare && this.navigator.canShare(this.data)) {
      this.shareViaShareApi(this.data);
    } else {
      this.shareViaFallbackModal(this.data);
    }
  }

  private shareFallbackComponent: Promise<Type<ShareButtonFallbackModalComponent>> | null = null;

  private async shareViaShareApi(shareData: ShareData) {
    try {
      const url = updateUtmTagsInUrl(shareData.url ?? '', 'utm_source', 'share_native');
      await this.navigator.share({ ...shareData, url });
    } catch (err) {
      console.log(err);
    }
  }

  private async shareViaFallbackModal(shareData: ShareData) {
    if (!this.shareFallbackComponent) {
      this.shareFallbackComponent = import('@rma/generic/ui/share/private/ui-share-button-fallback-modal').then(
        ({ ShareButtonFallbackModalComponent: component }) => component,
      );
    }

    this.shareFallbackComponent.then((component: Type<ShareButtonFallbackModalComponent>) => {
      this.bottomSheet.open(component, {
        data: shareData,
      });
    });
  }
}
